import { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';
import { RequestInterceptor } from '../Interceptor';
import { RequestLogConfig } from 'axios-logger/lib/common/types';
import * as AxiosLogger from 'axios-logger';

const requestLoggerConfig: RequestLogConfig = {
  headers: true,
  data: true,
  url: true,
  method: true,
};

export class RequestLoggingInterceptor implements RequestInterceptor {
  async onFulfilled(config: InternalAxiosRequestConfig): Promise<AxiosRequestConfig> {
    return AxiosLogger.requestLogger(config, requestLoggerConfig);
  }

  onRejected(error: any): any {
    return AxiosLogger.errorLogger(error);
  }
}
